<template>
<div class="ma-0 pa-0">
  <nav id="header" v-if="user && showHeader">
    <v-app-bar
      app
      fixed
      flat
      class="d-flex"
    >
      <div class="logo-wrapper">
        <img width="110px" :src="require('../../assets/logos/reveles-logo-white.svg')" alt="">
      </div>
      <OrganizationDropDown :style="{visibility: organizationVisibility}" />
      <v-list-item two-line class="user-profile px-0"
       v-if="user"
      >
        <v-menu
          :offset-y="true"
          nudge-bottom="15"
          transition="slide-y-transition"
          bottom
          left
          content-class="menu-class"
          @input="handleMenu"
          v-if="showUpgrade"
        >
          <template v-slot:activator="{ on }">
            <div s v-on="on" class="d-flex pointer align-center">
              <div class="upgrade">
                <span>Upgrade to see risk</span>
              </div>
            </div>
          </template>
          <div>
            <div class="arrow-up"></div>
            <div class="mask">
              <div>
                <div class="free-text">
                  Your free 30-day discovery profile is complete.
                </div>
                <div class="heading-text">
                  Upgrade now to get actionable insights.
                </div>
                <div class="description-text">
                  Reveles has been connected for 30 days, providing insights and patterns about your data’s dimensions.
                </div>
                <div class="stats-container">
                  <div class="stats-files">
                    <div class="stats-files-count mb-3">
                      {{countFiles}}
                    </div>
                    <div class="stats-files-file mb-3">
                      Files
                    </div>
                    <div class="stats-files-line mb-3"></div>
                    <div class="stats-files-size">
                      {{totalSize}}
                    </div>
                  </div>
                  <div class="stats-category">
                    <div class="percentage">
                      {{riskManagement+'%'}}
                    </div>
                    <div class="category">
                      Risk Management
                    </div>
                    <div class="line"></div>
                    <div class="percentage">
                      {{businessContinuity+'%'}}
                    </div>
                    <div class="category">
                      Business Continuity
                    </div>
                    <div class="line"></div>
                    <div class="percentage">
                      {{manageGovern+'%'}}
                    </div>
                    <div class="category">
                      Manage & Govern
                    </div>
                    <div class="line"></div>
                  </div>
                </div>
                <div class="line2"></div>
                <div class="bottom-description">
                  Now that you have a clear picture of the assets in your digital ecosystem, we can help you:
                </div>
                <div class="d-none d-md-flex flex-column mt-4">
                  <div class="point-text">
                    <div class="oval"></div>
                    <div>
                      Eliminate cyber-insurance barriers.
                    </div>
                  </div>
                  <div class="point-text">
                    <div class="oval"></div>
                    <div>
                      Minimize potential damages from ransomware and malware.
                    </div>
                  </div>
                  <div class="point-text">
                    <div class="oval"></div>
                    <div>
                      Implement a more intelligent and reliable network backup (AirGap) solution.
                    </div>
                  </div>
                </div>
                <div class="schedule-button" @click='scheduleCall'>
                  Schedule a Call to Upgrade
                </div>
              </div>
            </div>
          </div>
        </v-menu>
        <v-menu
          offset-y
          :close-on-content-click="false"
          bottom
          left
          width="220"
          content-class="myprofileclass"
        >
          <template v-slot:activator="{ on }">
            <div s v-on="on" class="d-flex pointer align-center">
              <v-list-item-avatar>
               <img :src="user.picture" @error="getAvatarUrl($event, user.name)">
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="user-name">{{ user.name | strLimit(100) }}</v-list-item-title>
              </v-list-item-content>
              <v-btn icon depressed small  class="menu-btn">
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </div>
          </template>

          <v-card
            elevation="0"
            class="ma-0 pa-0"
            width="220"
            min-height="250"
            style="border-radius: 15px 15px 15px 15px"
          >
            <v-row justify="center" class="pt-3 ml-3">
              <v-list-item-avatar size="95">
              <img :src="user.picture" @error="getAvatarUrl($event, user.name)">
            </v-list-item-avatar>

            </v-row>
            <v-icon
              style="
                position: absolute;
                top: 1.6em;
                left: 1em;
                pointer: cursor;
              "
              @click="showImageUpload=!showImageUpload"
              size="45"
            >
              mdi-circle
            </v-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  style="
                    position: absolute;
                        top: 2.67em;
                    left: 1.71em;
                    pointer: cursor;
                  "
                  @click="showImageUpload=!showImageUpload"
                  size="30"
                  color="white"
                >
                  mdi-camera-outline
                </v-icon>
              </template>
              <span>Change Image</span>
            </v-tooltip>
            <div class="ma-0 pa-0">
              <p style="text-align: center" class="h2 mt-9">
                <b>{{ user.name }}</b>
              </p>
              <p style="text-align: center" class="ma-0 pa-0 h3 mt-n5">
               Role: {{ computedRole }}
              </p>
            </div>

            <v-list dense class="">
              <v-list-item
                v-for="(item, index) in profileItems"
                :key="index"
                @click="profileItemCall(item)"
                class="ma-0 pa-0 px-5"
              >
                <v-list-item-icon
                >
                  <v-icon v-text="item.icon" color="#474747"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle

                    v-text="item.title"
                  >
                  </v-list-item-subtitle>
                </v-list-item-content>
                <!-- <v-menu
                  v-if="
                    item.key === 'profileSettings' &&
                    item.icon === 'mdi-account-settings-outline'
                  "
                  :close-on-content-click="false"
                  offset-x
                  bottom
                  width="220"
                  content-class="profileSettingsMenu"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item v-on="on" v-bind="attrs" class="ma-0 pa-0">
                      <v-list-item-icon>
                        <v-icon v-text="item.icon" color="#474747"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-subtitle
                        v-text="item.title"
                        v-on="on"
                      ></v-list-item-subtitle>
                    </v-list-item>
                  </template>
                  <v-card
                    elevation="0"
                    class="ma-0 pa-0"
                    width="220"
                    min-height="150"
                    style="border-radius: 15px !important"
                  >
                    <div
                      style="
                        display: flex;
                        background-color: #e8e8e8;
                        border-radius: 15px 15px 0px 0px;
                      "
                      class="pt-3"
                    >
                      <v-icon class="pl-4 mt-n4" color="#474747"
                        >mdi-account-outline</v-icon
                      >
                      <p class="body-2 pl-8">Profile Settings</p>
                    </div>
                    <div
                      v-for="(item, i) in profileSettingsItems"
                      :key="i"
                      class="mb-n2 ma-0 pa-0"
                    >
                      <v-list
                        v-if="item.key !== 'changePassword'"
                        dense
                        style="
                          background-color: transparent;
                          border-radius: 15px 15px 15px 15px;
                        "
                      >
                        <v-list-item @click="profileSettingsItemCall(item)">
                          <v-list-item-icon>
                            <v-icon
                              v-text="item.icon"
                              color="#474747"
                            ></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-subtitle v-text="item.title">
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-card
                        elevation="0"
                        class=""
                        color="transparent"
                        v-if="namechange && item.key === 'changeName'"
                      >
                        <v-text-field
                          class="select-field py-3 customInputRound ml-2 mt-2 mr-2"
                          dense
                          label="User Name"
                          v-model="username"
                          outlined
                        >
                        </v-text-field>
                        <v-card-actions class="mt-n7">
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            class="save-btn"
                            :disabled="isGoingToReset"
                            :loading="isGoingToReset"
                            @click="save()"
                          >
                            Submit
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </div>
                  </v-card>
                </v-menu> -->
              </v-list-item>

            </v-list>
          </v-card>
        </v-menu>
      </v-list-item>
      <v-spacer></v-spacer>
      <v-btn
        @click="$router.push('/session/signup').catch(err => {})"
        v-if="!user"
        depressed
        class="pa-3">
        Sign Up
        <v-icon right>person_add</v-icon>
      </v-btn>
      <v-divider
        v-if="!user"
        class="mx-4"
        vertical>
      </v-divider>
      <v-btn
        @click="$router.push('/session/login').catch(err => {})"
        v-if="!user"
        depressed
        class="pa-3">
        Login
        <v-icon right>exit_to_app</v-icon>
      </v-btn>
      <v-divider
        v-if="!user"
        class="mx-4"
        vertical>
      </v-divider>
    </v-app-bar>
  </nav>
  <image-upload
    field="picture"
    @crop-success="cropSuccess"
    v-model="showImageUpload"
    :width="200"
    :height="200"
    langType="en"
    img-format="png">
  </image-upload>
  <edit-profile
    :show="isEditProfileCalled"
    :active-user="user"
    :current-organization="currentOrganization"
    @onClose="toggleIsEditProfileCalled"
    @onSave="saveUserProfile"
  ></edit-profile>
</div>
</template>

<script>
import '@/pusher'
import { mapGetters, mapState } from 'vuex'
import avatarUrlMixin from '../../mixins/avatarUrlMixin'
import OrganizationDropDown from '@/components/OrganizationDropDown'
import { convert } from '@/utils/main_helper'
import imageUpload from 'vue-image-crop-upload'
import editProfile from '../settings/profile/editProfile.vue'
export default {
  name: 'Header',
  mixins: [avatarUrlMixin],
  components: {
    OrganizationDropDown,
    imageUpload,
    editProfile
  },
  computed: {

    ...mapState('discoveryServices', ['scanList', 'size', 'last_modified']),
    ...mapGetters(['user', 'license', 'paymentInformation', 'currentOrganization']),
    organizationVisibility () {
      const route = this.$route.name.toLowerCase()
      if (route.indexOf('editor') > -1 && route.indexOf('settings') !== 0) {
        return 'hidden'
      }

      if (route.indexOf('organization') === 0) {
        return 'hidden'
      }
      return ''
    },
    showUpgrade () {
      const now = Date.now()
      if (this.license && this.scanList) {
        return ((this.dateDiffDays(now, this.license.date_created) > 30) && this.license.description === 'free' && (this.scanList.length > 0))
      }
      return false
    },
    totalSize () {
      const totalSize = this.size ? this.size.map(s => Number(s.total_size)).reduce((a, b) => {
        return a + b
      }, 0) : 0
      return convert(totalSize, 'GB', 1000)
    },
    countFiles () {
      const sum = this.size ? this.size.map(s => Number(s.total_count)).reduce((a, b) => {
        return a + b
      }, 0) : 0
      return convert(sum, 'count', 1000)
    },
    computedRole () {
      const userRole = this.user.role[this.currentOrganization.entity_id] || 'guest'
      return userRole.charAt(0).toUpperCase() + userRole.slice(1)
    }
  },
  mounted () {
    this.themes = Object.keys(this.$store.state.colorPaletteServices.themes)
    this.username = this.user.name
    this.profilePicture = this.user.picture
    this.isUserLoggedIn = !!this.user
  },
  filters: {
    strLimit: function (value, size) {
      if (!value) return ''
      value = value.toString()

      if (value.length <= size) {
        return value
      }
      return value.substr(0, size) + '...'
    }
  },
  data () {
    return {
      show: false,
      showHeader: false,
      closeOnContentClick: false,
      closeOnContentClickUpgrade: false,
      theme: 'Light Mode',
      themes: [],
      search: '',
      drawer: true,
      profileEditor: {
        name: 'Update Profile', path: '/editprofile'
      },
      resetPass: {
        name: 'Reset Password', path: '/session/reset-password?isLogged=1'
      },
      riskManagement: '',
      manageGovern: '',
      businessContinuity: '',

      showImageUpload: false,
      profilePicture: '',
      username: '',
      profileItems: [
        { title: 'Edit Profile', icon: 'mdi-account-settings-outline', key: 'profileSettings' },
        { title: 'Reset Password', icon: 'mdi-account-convert-outline', key: 'resetPassword' },
        { title: 'Log Out', icon: 'mdi-login', key: 'logOut' }
      ],
      // profileSettingsItems: [
      //   { title: 'Change Password', icon: 'mdi-account-key-outline', key: 'changePassword' },
      //   { title: 'Reset Password', icon: 'mdi-account-convert-outline', key: 'resetPassword' },
      //   { title: 'Change Name', icon: 'mdi-account-edit-outline', key: 'changeName' }
      // ],
      passwordchange: false,
      namechange: false,
      resetpassword: false,
      nameRules: [
        v => !!v || 'Name is required'
      ],
      isGoingToReset: false,
      isEditProfileCalled: false

    }
  },
  methods: {
    profileItemCall (item) {
      if (item.key === 'profileSettings') {
        this.isEditProfileCalled = !this.isEditProfileCalled
      }
      if (item.key === 'logOut') {
        this.logoutUser()
      } else if (item.key === 'resetPassword') {
        this.handlePasswordReset()
      }
    },
    toggleIsEditProfileCalled () {
      this.isEditProfileCalled = false
    },
    saveUserProfile (payload) {
      this.username = payload.name
      this.save()
    },
    setAvatar () {
      this.profilePicture = this.getAvatarUrl(null, this.user.name, true)
    },
    save () {
      // avatar_url field is removed when a profile_pic is uploaded
      const userData = {
        entity_id: this.user.entity_id,
        user_id: this.user.user_id,
        affiliate_id: JSON.parse(localStorage.getItem('reveles-user')).affiliate_id,
        email: JSON.parse(localStorage.getItem('reveles-user')).email,
        email_verified: this.user.email_verified,
        nickname: JSON.parse(localStorage.getItem('reveles-user')).nickname,
        blocked: false,
        name: this.username,
        picture: this.profilePicture,
        eula_accepted: true,
        tour_complete: !!this.user?.tour_complete
      }
      this.$store.dispatch('updateProfile', { data: userData, shouldReload: true })
    },
    cropSuccess (imgDataUrl) {
      this.profilePicture = imgDataUrl
      this.save()
    },
    // profileSettingsItemCall (item) {
    //   if (item.key === 'changePassword') {
    //     this.passwordchange = !this.passwordchange
    //     this.resetpassword = false
    //     this.namechange = false
    //   }
    //   if (item.key === 'changeName') {
    //     this.namechange = !this.namechange
    //     this.resetpassword = false
    //     this.passwordchange = false
    //   }
    //   if (item.key === 'resetPassword') {
    //     this.resetpassword = !this.resetpassword
    //     this.resetpassword = false
    //     this.passwordchange = false
    //     this.handlePasswordReset()
    //   }
    // },
    async handlePasswordReset () {
      this.isGoingToReset = true
      await this.$store.dispatch('resetPassword', this.user.email)
      this.isGoingToReset = false
    },
    scheduleCall () {
      window.open('https://meetings.hubspot.com/brack1/upgrade')
    },
    logoutUser () {
      this.$store.dispatch('signOutUserFromApi', this.$router)
        .then(() => {
          if (this.$useAuth0Login) {
            this.$auth.logout({
              returnTo: window.location.origin
            })
          } else {
            this.$router.push('/session/login')
          }
        })
    },
    to (path) {
      this.closeOnContentClick = true
      this.$router.push(`${path}`).catch(err => {})
    },
    changeTheme (theme) {
      this.theme = theme
      this.closeOnContentClick = true
      var logoWraper = document.getElementsByClassName('logo-wrapper')
      logoWraper[0].children[0].style.filter = this.theme === 'Light Mode'
        ? 'invert(0%)' : 'invert(100%)'
      var navbarIcons = document.getElementsByClassName('nav-icon')
      navbarIcons.forEach(n => {
        n.children[0].style.filter = this.theme === 'Light Mode'
          ? 'invert(0%)' : 'invert(100%)'
      })
      this.$store.commit('colorPaletteServices/changeTheme', this.theme)
    },
    overlay (status) {
      var x = document.getElementsByClassName('v-main__wrap')
      if (status) {
        x[0].classList.add('overlay')
      } else {
        x[0].classList.remove('overlay')
      }
    },
    handleMenu (event) {
      if (event) this.overlay(true)
      else this.overlay(false)
    },
    dataTypePercentage () {
      let bc = []
      let mg = []
      let rm = []
      this.last_modified.forEach(element => {
        console.log(element)
        if (this.isBusinessContinuity(element)) {
          bc.push(element.total_count)
        } else if (this.isManageGovern(element)) {
          mg.push(element.total_count)
        } else if (this.isRiskManagement(element)) {
          rm.push(element.total_count)
        }
      })

      bc = bc.reduce((a, b) => Number(a) + Number(b), 0)
      mg = mg.reduce((a, b) => Number(a) + Number(b), 0)
      rm = rm.reduce((a, b) => Number(a) + Number(b), 0)
      const total = bc + mg + rm
      this.riskManagement = rm ? ((rm * 100) / total).toFixed(2) : 0
      this.manageGovern = mg ? ((mg * 100) / total).toFixed(2) : 0
      this.businessContinuity = bc ? ((bc * 100) / total).toFixed(2) : 0
    },
    isBusinessContinuity (element) {
      return element.label === '< 1' || element.label === '< 1yr old' || element.label === '1 - 2' || element.label === '>= 1 and < 2 yrs' ||
        element.label === '2 - 3' || element.label === '>= 2 and < 3 yrs'
    },
    isManageGovern (element) {
      return element.label === '3 - 4' || element.label === '>= 3 and < 4 yrs' || element.label === '4 - 5' || element.label === '>= 4 and < 5 yrs' ||
        element.label === '5 - 6' || element.label === '>= 5 and < 6 yrs'
    },
    isRiskManagement (element) {
      return element.label === '6 - 7' || element.label === '>= 6 and < 7 yrs' || element.label === '> 7' || element.label === '>= 7yrs' ||
        element.label === '7 - 8' || element.label === '>= 7 and < 8 yrs' ||
        element.label === '8 - 9' || element.label === '>= 8 and < 9 yrs' ||
        element.label === '9 - 10' || element.label === '>= 9 and < 10 yrs' ||
        element.label === '> 10' || element.label === '>= 10yrs'
    },
    dateDiffDays (now, created) {
      const diffTime = Math.abs(now - (created * 1000))
      const diffDays = Math.ceil(diffTime / 86400000) // 1000 * 60 * 60 * 24
      return diffDays
    }
  },
  created () {
    const { meta } = this.$route

    this.showHeader = meta && meta.requiresAuth
  },
  watch: {
    $route () {
      const { meta } = this.$route
      this.showHeader = meta && meta.requiresAuth
    },
    last_modified () {
      this.dataTypePercentage()
    }
  }
}

</script>

<style lang="scss">
  #header {
    .v-app-bar {
      z-index: 99;
      left: 0 !important;
    }

    .pointer {
       cursor: pointer;
    }

    .text-style, .user-name {
       font-family: 'gt_america';
       font-weight: 500 !important;
    }
    .logo-wrapper {
      width: 180px;
      flex: 0 0 180px;
      display: flex;
      align-items: center;
    }
    .upgrade {
      height: 35px;
      width: 264px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-radius: 25px;
      background-color: #3ACA56;
      color: #212338;
      font-family: "gt_america_extendedBd";
      font-size: 12px;
      letter-spacing: 1.97px;
      line-height: 17px;
      text-align: center;
      vertical-align: middle;
      text-transform: uppercase;
      margin-right: 10px;
    }
  }
  .selected-item {
    background: $selected-nav;
  }
  .overlay {
    background: rgba(33, 35, 55, 0.1) !important;
  }
</style>
<style lang="scss" scoped>
  .myprofileclass{
    border-radius: 15px;
  }
  .menu-class {
    position: absolute;
    margin-left: 60px;
    box-shadow: none !important;
  }
  .mask {
    height: 685px;
    width: 400px;
    border-radius: 6px;
    background-color: #FFFFFF;
    box-shadow: 0 4px 0 0 rgb(32 33 36 / 28%);
    padding: 40px;
    padding-right: 25px;
    padding-left: 40px;
  }
  .arrow-up {
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid white;
    margin: 0 auto;
  }
  .free-text {
    color: #212338;
    font-family: "gt_america";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 15px;
    margin-bottom: 15px;
  }
  .heading-text {
    color: #212338;
    font-family: "gt_america";
    font-size: 30px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 32px;
    text-align: left;
    margin-bottom: 10px;
  }
  .description-text {
    color: #212338;
    font-family: "gt_america";
    font-size: 14px;
    letter-spacing: 0;
    line-height: 18px;
    margin-bottom: 35px;
  }
  .stats-container {
    display: flex;
  }
  .stats-files {
    height: 140px;
    width: 140px;
    letter-spacing: 0;
    text-align: center;
    padding: 35px 15px;
    .stats-files-count {
      color: #212338;
      font-family: "gt_america";
      font-size: 32.2px;
      font-weight: bold;
      line-height: 21px;
    }
    .stats-files-file {
      color: #212338;
      font-family: "gt_america";
      font-size: 13px;
      font-weight: 500;
      line-height: 15px;
    }
    .stats-files-line {
      box-sizing: border-box;
      height: 1px;
      width: 16px;
      border: 1px solid #000000;
      margin: 0 auto;
    }
    .stats-files-size{
      color: #212338;
      font-family: "gt_america";
      font-size: 14px;
      font-weight: bold;
      line-height: 15px;
    }
  }
  .stats-category {
    letter-spacing: 0;
    text-align: left;
    color: #212338;
    margin-left: 30px;
    .percentage {
      font-family: "gt_america";
      font-size: 14px;
      line-height: 15px;
    }
    .category {
      font-family: "gt_america";
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 15px;
      margin-bottom: 7px;
    }
    .line {
      box-sizing: border-box;
      width: 140px;
      border: 0.2px solid #000000;
      margin-bottom: 10px;
    }
  }
  .line2 {
    box-sizing: border-box;
    height: 1px;
    width: 330px;
    border: 1px solid #000000;
    margin: 0 auto;
    margin-top: 44px;
  }
  .bottom-description {
    color: #212338;
    font-family: "gt_america";
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
    margin-top: 32px;
  }

  .point-text {
    font-family: "gt_america";
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    color: #212338;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
    margin-bottom: 10px;
  }
  .oval{
    height: 5px;
    width: 5px;
    background-color: #3ACA56;
    margin-right: 15px;
    border-radius: 50% !important;
  }
  .schedule-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    color: #212338;
    font-family: "gt_america_extendedBd";
    font-size: 13px;
    letter-spacing: 1.97px;
    line-height: 17px;
    text-align: center;
    height: 50px;
    width: 330px;
    border-radius: 25px;
    background-color: #3ACA56;
    margin-top: 20px;
    cursor: pointer;
  }
</style>
